export const DNA_MATCHES: string = 'DNA_MATCHES';
export const PAWFECT_MATCHES: string = 'PAWFECT_MATCHES';

export const MATCHES_PAGE_SIZE = 5;

export const CLOSE_FAMILY_GROUP = 'CLOSE_FAMILY';
